module.exports = __webpack_public_path__ + "static/media/spazio.d187069c.jpg";